import { ChainId } from '@pancakeswap/chains'
import FarmsPulseHelper from './369'

export const getFarmsPriceHelperLpFiles = (chainId: ChainId) => {
  switch (chainId) {
    case ChainId.PULSE:
      return FarmsPulseHelper
    default:
      return []
  }
}
